<template>
  <div id="taskExportHeader">
    <div v-if="!loading" class="contHeader">
      <div class="titleBtn">
        <span class="titleT">Ajustes de exportación automática</span>
        <div>
          <v-switch
            color="#27e96a"
            v-if="enabled"
            v-model="dataEnabled.enabled"
            :loading="loadingS"
            @change="setEnabled()"
          ></v-switch>
          <div @click="newTaskExport()" class="btnConfig">
            <v-icon>mdi-cog</v-icon>
          </div>
        </div>
      </div>
      <div class="contDataTaskExport" v-if="enabled">
        <div class="cont flex-7">
          <div class="contItem margin-bot">
            <v-icon>mdi-calendar-month</v-icon>
            <span>{{ data.type == "daily" ? "Diaria" : "Semanal" }}</span>
            <div v-if="data.dow" class="dayOfWeek">
              <span>{{ getDow() }}</span>
            </div>
          </div>
          <div class="contItem">
            <v-icon>mdi-clock-outline</v-icon>
            <span class="w-500">{{ data.hour }}:00</span>
          </div>
        </div>
        <div class="cont flex-1">
          <div class="fitW">
            <div class="contItem margin-bot">
              <v-icon>mdi-weather-cloudy</v-icon>
              <span v-if="listStorage.length > 0">{{ getNameBucket() }}</span>
            </div>
            <div v-if="listFilenameFormat.length > 0" class="contItem">
              <v-icon>mdi-tag</v-icon>
              <div
                v-for="(item, index) in getFormatdivide()"
                :key="index"
                class="tag"
                :class="{ var: isVar(item) }"
              >
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contLine">
        <div class="line"></div>
      </div>
      <div v-if="!enabled" class="contNoConfiguration">
        <div class="iconAlert">
          <IconAlert></IconAlert>
        </div>
        <span class="alertText"
          >No se ha estrablecido ninguna configuración para realizar la
          exportación automática</span
        >
      </div>
      <v-chip-group column>
        <v-chip
          class="customChip"
          v-for="item in pathArray"
          :key="item + '-path'"
        >
          <v-icon left> mdi-folder-outline </v-icon>
          {{ item }}
        </v-chip>
      </v-chip-group>
      <div v-if="enabled" class="contAudio">
        <v-icon color="#27e96a">mdi-music</v-icon>
        <span>{{ audioFormat }}</span>
      </div>
    </div>
    <div v-else class="contHeader center mt-4">
      <v-progress-circular indeterminate color="black"></v-progress-circular>
    </div>
    <v-snackbar v-model="showError" color="red" :timeout="2000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
// icons
/* import IconConfig from "@/assets/iconsTaskExport/Config.svg"; */
import IconAlert from "@/assets/iconsTaskExport/Alert.svg";

import { mapGetters } from "vuex";
export default {
  components: {
    IconAlert,
  },
  data() {
    return {
      data: null,
      dataEnabled: null,
      pathArray: [],
      week: [
        { name: "DOM", value: 1 },
        { name: "LUN", value: 2 },
        { name: "MAR", value: 3 },
        { name: "MIE", value: 4 },
        { name: "JUE", value: 5 },
        { name: "VIE", value: 6 },
        { name: "SAB", value: 7 },
      ],
      loading: true,
      loadingS: false,
      audioFormat: null,
      showError: false,
      textError: null,
    };
  },
  mounted() {
    this.getTaskExport();
  },
  computed: {
    ...mapGetters("task", { taskExport: "taskExport" }),
    ...mapGetters("filenameFormat", {
      listFilenameFormat: "filenameFormatTable",
    }),
    ...mapGetters("storage", { listStorage: "storageTable" }),
    enabled() {
      return (
        this.data && this.data.format && this.data.storageId && this.data.path
      );
    },
  },
  methods: {
    newTaskExport() {
      this.$router.push("/task/newtaskexport");
    },
    divideString() {
      this.pathArray = this.data.path.split("/");
      if (this.data.path.startsWith("/")) {
        this.pathArray.splice(0, 1);
      }
    },
    isVar(string) {
      if (string.startsWith("{") && string.endsWith("}")) {
        return true;
      } else {
        return false;
      }
    },
    getDow() {
      const dow = this.week.find((item) => item.value === this.data.dow);
      return dow.name;
    },
    getFormatdivide() {
      const format = this.listFilenameFormat.find(
        (item) => item.id === this.data.format
      );
      this.audioFormat = format.filename_format;
      let test = format.filename_format.replace(".mp3", "");
      test = test.split("_");
      return test;
    },
    getNameBucket() {
      const name = this.listStorage.find(
        (item) => item.id === this.data.storageId
      );
      return name.nameBucket;
    },
    async getTaskExport() {
      try {
        await this.$store.dispatch("task/getTaskExport");
        if (Object.keys(this.taskExport).length > 1) {
          this.dataEnabled = JSON.parse(JSON.stringify(this.taskExport));
          this.data = this.taskExport;
        }
        if (
          this.data &&
          this.data.format &&
          this.data.storageId &&
          this.data.path
        ) {
          this.$store.dispatch("filenameFormat/getFilenameFormat");
          this.$store.dispatch("storage/getAllStorage");
          this.divideString();
          this.setHourLocal();
        }
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
      this.loading = false;
    },
    async setEnabled() {
      this.loadingS = true;
      try {
        await this.$store.dispatch("task/createTaskExport", this.dataEnabled);
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
      this.loadingS = false;
    },
    setHourLocal() {
      const offset = new Date().getTimezoneOffset();
      const tdiff = Math.ceil(offset / 60);
      this.data.hour = this.data.hour - tdiff;
      if (this.data.hour < 0) {
        this.data.hour = this.data.hour + 24;
        if (this.data.type == "weekly") {
          if (this.data.dow == 1) {
            this.data.dow = 7;
          } else {
            this.data.dow = this.data.dow - 1;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
.v-application .primary--text {
  color: #27e96a !important;
  caret-color: #27e96a !important;
}
#taskExportHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  .contHeader {
    background-color: $complementary-color;
    box-shadow: 2px 1px -1px rgba(0, 0, 0, 0.2), 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    margin: 28px 50px;
    padding: 15px;
    width: 100%;
    &.center {
      display: flex;
      justify-content: center;
    }
    .titleT {
      font-size: 26px;
      letter-spacing: 2px;
      color: #525b62;
      font-weight: 500;
      font-family: sans-serif;
      text-shadow: 0px 0.4px #525b62;
    }
    .titleBtn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 25px;
      animation: fade 1s ease-in-out;
    }
    .btnConfig {
      width: 35px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e5ea;
      border-radius: 5px;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      svg {
        cursor: pointer;
      }
    }
    .contNoConfiguration {
      border: 1px solid #f44336;
      margin: 15px 0 0 0;
      border-radius: 3px;
      padding: 8px;
      background: #eff3f6;
      display: flex;
      align-items: center;
      animation: fade 1s ease-in-out;
      .alertText {
        color: #f44336;
        font-size: 13px;
        margin-left: 10px;
      }
    }
    .contLine {
      width: 100%;
      display: flex;
      justify-content: center;
      .line {
        border-bottom: 1px solid #e3e4e6;
        width: 100%;
      }
    }
    .contDataTaskExport {
      display: flex;
      border-top: 1px solid #e3e4e6;
      flex-wrap: wrap;
      animation: fade 1s ease-in-out;
      .cont {
        min-width: 330px;
        padding: 10px 0;
        &.flex-1 {
          flex: 1;
          display: flex;
          justify-content: center;
          position: relative;
          &::after {
            content: "";
            height: 80%;
            position: absolute;
            left: 0;
            border: 1px solid #e3e4e6;
          }
        }
        &.flex-7 {
          flex: 0.7;
        }
        .contItem {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          &.center {
            justify-content: center;
          }
          &.margin-bot {
            margin-bottom: 20px;
          }
          span {
            font-size: 14px;
          }
          .w-500 {
            font-weight: 500;
          }
          .dayOfWeek {
            background: #eff2f7;
            padding: 0px 5px;
            border-radius: 10px;
            border: 1px solid #cecfd2;
          }
        }
      }
    }
    .contAudio {
      display: flex;
      align-items: center;
      background: #eff2f7;
      border-radius: 10px;
      padding: 2px 10px;
      border: 1px solid $primary-color;
      margin: 14px 0 0 0;
      width: fit-content;
      animation: fade 1s ease-in-out;
      span {
        font-size: 14px;
        color: $background-secondary;
        margin-left: 10px;
      }
    }
    .iconAlert {
      min-width: 22px;
      min-height: 22px;
    }
    .tag {
      border: 1px solid $secondary-color;
      border-radius: 15px;
      padding: 0px 10px;
      span {
        color: $primary-color;
        cursor: default;
      }
      &.var {
        background: $secondary-color;
        span {
          color: #ffffff;
        }
      }
    }
  }
  .v-chip {
    &.customChip {
      background: #eff2f7;
      border: 1px solid #cecfd2;
      animation: fade 1s ease-in-out;
      .v-chip__content {
        color: $background-secondary;
      }
      .v-icon {
        color: $primary-color;
      }
    }
  }
  .v-slide-group__wrapper {
    flex: unset;
  }
  .v-slide-group__content {
    width: fit-content;
    border-bottom: 2px solid #cecfd263;
  }
  .fitW {
    width: fit-content;
  }
  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media (max-width: 800px) {
    .contDataTaskExport {
      .cont {
        &.flex-1 {
          justify-content: flex-start !important;
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
